export const USER_ANNOUNCEMENT_TYPES = {
    Info: "info",
    Warning: "warning",
    Announcement: "announcement",
    Alerts: "alerts",
};
//# sourceMappingURL=userAnnouncements.js.map